import { TextPill } from 'components/FbUI/TextPill'
import { Tag } from 'models/tags'
import { MULTI_VALUE_SELECT_COLORS } from 'utils/constants'

// Default DS2026 Gray badge palette — matches ContactTagPill fallback so
// tags without a user-picked color stay legible on light surfaces.
const DEFAULT_TAG_BG = '#F3F4F6'
const DEFAULT_TAG_TEXT = '#374151'
const DELETED_TAG_LABEL = '[Tag deleted]'

export function renderTagPills(
  tagsIds: number[],
  tagsMap: Record<string, Tag>,
  deletedLabel: string = DELETED_TAG_LABEL
): React.ReactNode {
  if (!Object.keys(tagsMap).length) return ''
  return (
    <div data-event-pills className="mt-1 flex flex-wrap items-center gap-1">
      {tagsIds.map((tagId) => {
        const tag = tagsMap[tagId]
        if (!tag) {
          return (
            <TextPill
              key={`deleted-${tagId}`}
              textColor={DEFAULT_TAG_TEXT}
              backgroundColor={DEFAULT_TAG_BG}
            >
              {deletedLabel}
            </TextPill>
          )
        }
        const palette = tag.color
          ? MULTI_VALUE_SELECT_COLORS.find((c) => c.background === tag.color)
          : null
        return (
          <TextPill
            key={tag.id}
            textColor={palette?.text ?? DEFAULT_TAG_TEXT}
            backgroundColor={palette?.background ?? DEFAULT_TAG_BG}
          >
            {tag.tag}
          </TextPill>
        )
      })}
    </div>
  )
}
